import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  constructor(private readonly http: HttpClient) { }

  public sendContactEmail(data: { contactBody: {
    name: string;
    email: string;
    subject: string;
    message: string;
  } }): Observable<string> {
    return this.http.post<string>(`${environment.apiUrlBasePath}/contact/sendContactEmail`, data);
}
}
